import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { listAudienceUsers } from '~/services/PromoService';

import { audienceUserQueryKeys } from './audienceQueryKeys';

type Params = {
  query: Parameters<typeof listAudienceUsers>[0];
  enabled?: boolean;
};

export function useListAudienceUsers({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: audienceUserQueryKeys.list(query),
    queryFn: async ({ signal }) => listAudienceUsers(query, { signal }),
    enabled,
    placeholderData: keepPreviousData,
  });
}
